import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const MCCERTS_2548_SUBSCRIPTIONS_ENTRY_POINT_I18N_NAMESPACE =
  '@mc/next/experiments/mccerts-2548_v1-subscriptions-entry-point'

export const i18nInstance = registerI18nResources({
  namespace: MCCERTS_2548_SUBSCRIPTIONS_ENTRY_POINT_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
